export enum ResourceType {
	COMPANIES = 'companies',
	ROLES = 'roles',
	USERS = 'users',
	INVITES = 'invites',
	API_KEYS = 'api-keys',
}
